module.exports = __webpack_public_path__ + "static/media/entrance-brand.54f62841.png";